import script from "./CustomDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&setup=true&lang=js"

import "./CustomDropdown.vue?vue&type=style&index=0&id=5ce17d43&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce17d43"]])

export default __exports__